import React from 'react';
import { Link } from 'react-router-dom';
import { useFormConfig } from '../../hooks/useFormConfig';

export type BreadcrumbsProps = {
  sectionName: string;
  sectionTitle?: string;
};

function Breadcrumbs({ sectionName, sectionTitle }: BreadcrumbsProps) {
  const { tenant } = useFormConfig();

  // 🔹 dynamically import tenant config
  let tenantConfig: any = {};
  try {
    tenantConfig = require(`../../config/configs/${tenant}`).default ?? {};
  } catch {
    // fallback to empty config if tenant file not found
  }

  const rootLabel = tenantConfig.formName ?? 'Your Response';

  return (
    <nav className="govuk-breadcrumbs">
      <ol className="govuk-breadcrumbs__list">
        <li className="govuk-breadcrumbs__list-item">
          <Link className="govuk-breadcrumbs__link" to={`/${tenant}/`}>
            {rootLabel}
          </Link>
        </li>
        <li className="govuk-breadcrumbs__list-item">
          <Link
            data-testid="breadcrumbs-section-name"
            className="govuk-breadcrumbs__link"
            to={`/${tenant}/`}
          >
            {sectionName}
          </Link>
        </li>
        {sectionTitle && (
          <li className="govuk-breadcrumbs__list-item">
            <span data-testid="breadcrumbs-section-title">{sectionTitle}</span>
          </li>
        )}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
